// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"81dda2ab","511":"0d3d3041","548":"b5d4f366","720":"b371b81b","817":"0c99a626"}[chunkId] + ".chunk.js";
};